import React from "react";
import { connect } from "react-redux";
import { browserHistory as history } from "react-router";
import {
  TextField,
  PrimaryButton,
  Link,
  MessageBar,
  MessageBarType,
} from "office-ui-fabric-react";
import helpers from "../../helpers";
import { login } from "../../axios/auth";

export class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: "",
    };
  }

  dismissMsg() {
    this.setState({
      msg: "",
    });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.auth.user) {
      history.push("/");
    } else if (newProps.auth.error) {
      this.setState({
        msg: newProps.auth.error.data,
      });
    }
  }

  handleLogin(event) {
    event.preventDefault();
    var email = this.refs.email.value;
    var password = this.refs.password.value;
    if (!email) {
      this.setState({
        msg: "Please enter your email address",
      });
    } else if (!password) {
      this.setState({
        msg: "Please enter your password",
      });
    } else {
      this.setState({
        msg: "",
      });
      this.props.dispatch(login(email, password));
    }
  }

  render() {
    const { msg } = this.state;
    const { error } = this.props.auth;

    return (
      <form onSubmit={(event) => this.handleLogin(event)}>
        <TextField ref="email" label="Email" type="email"></TextField>
        <TextField ref="password" label="Password" type="password"></TextField>
        {(msg || (error && error.message)) && (
          <MessageBar
            messageBarType={MessageBarType.error}
            onDismiss={() => this.dismissMsg()}
          >
            {msg || (error && error.message)}
          </MessageBar>
        )}
        <div>
          <PrimaryButton
            className="mt-5"
            onClick={(event) => this.handleLogin(event)}
          >
            Login
          </PrimaryButton>
        </div>
        <div className="mt-20 ms-fontSize-m">
          <Link>Can't sign in / Forgot your password?</Link>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state, own_props) {
  return {
    auth: state.auth,
  };
}
export default connect(mapStateToProps)(LoginForm);



// WEBPACK FOOTER //
// ./client/components/common/LoginForm.js